<template>
  <div class="relative min-h-screen flex flex-col">
    <!-- Main Content -->
    <div
      class="flex-1 flex flex-col justify-center items-center relative min-h-screen"
      :style="`background-image: url(${require('@/assets/Booking/bookingbg.png')}); background-size: cover; background-position: center;`"
    >
      <div class="flex w-full bg-transparent text-white items-center">
        <!-- Time Blocks Container -->
        <div
          class="flex flex-col md:flex-row w-full items-center md:items-stretch justify-center"
        >
          <!-- Breakfast -->
          <div
            class="flex-1 flex flex-col items-center justify-center h-[120px] md:h-[200px] lg:h-[300px] cursor-pointer transition duration-300 hover:text-yellow-400 hover:drop-shadow-[0_0_10px_rgba(255,255,0,0.8)] mb-6 md:mb-0"
            @click="handleClick('breakfast')"
          >
            <span
              class="text-[25px] font-medium"
              style="font-family: 'DM Sans', sans-serif"
            >
              {{ $t("bookingDuration.breakfast") }}
            </span>
            <div class="w-2/3 h-px bg-opacity-20 my-2"></div>
            <span
              class="text-[20px] font-normal mb-1"
              style="font-family: 'DM Sans', sans-serif"
            >
              {{ $t("bookingDuration.days") }}
            </span>
            <span
              class="text-[20px] font-normal"
              style="font-family: 'DM Sans', sans-serif"
            >
              {{ $t("bookingDuration.breakfastTime") }}
            </span>
          </div>

          <!-- Divider -->
          <div
            class="hidden md:block w-px bg-white bg-opacity-30 mx-8 h-[120px] md:h-[200px] lg:h-[300px]"
          ></div>
          <div
            class="block md:hidden w-4/5 h-px bg-white bg-opacity-30 my-2 mx-auto"
          ></div>

          <!-- Lunch -->
          <div
            class="flex-1 flex flex-col items-center justify-center h-[120px] md:h-[200px] lg:h-[300px] cursor-pointer transition duration-300 hover:text-yellow-400 hover:drop-shadow-[0_0_10px_rgba(255,255,0,0.8)] mb-6 md:mb-0"
            @click="handleClick('lunch')"
          >
            <span
              class="text-[25px] font-medium"
              style="font-family: 'DM Sans', sans-serif"
            >
              {{ $t("bookingDuration.lunch") }}
            </span>
            <div class="w-2/3 h-px bg-opacity-20 my-2"></div>
            <span
              class="text-[20px] font-normal mb-1"
              style="font-family: 'DM Sans', sans-serif"
            >
              {{ $t("bookingDuration.days") }}
            </span>
            <span
              class="text-[20px] font-normal"
              style="font-family: 'DM Sans', sans-serif"
            >
              {{ $t("bookingDuration.lunchTime") }}
            </span>
          </div>

          <!-- Divider -->
          <div
            class="hidden md:block w-px bg-white bg-opacity-30 mx-8 h-[120px] md:h-[200px] lg:h-[300px]"
          ></div>
          <div
            class="block md:hidden w-4/5 h-px bg-white bg-opacity-30 my-2 mx-auto"
          ></div>

          <!-- Dinner -->
          <div
            class="flex-1 flex flex-col items-center justify-center h-[120px] md:h-[200px] lg:h-[300px] cursor-pointer transition duration-300 hover:text-yellow-400 hover:drop-shadow-[0_0_10px_rgba(255,255,0,0.8)]"
            @click="handleClick('dinner')"
          >
            <span
              class="text-[25px] font-medium"
              style="font-family: 'DM Sans', sans-serif"
            >
              {{ $t("bookingDuration.dinner") }}
            </span>
            <div class="w-2/3 h-px bg-opacity-20 my-2"></div>
            <span
              class="text-[20px] font-normal mb-1"
              style="font-family: 'DM Sans', sans-serif"
            >
              {{ $t("bookingDuration.days") }}
            </span>
            <span
              class="text-[20px] font-normal"
              style="font-family: 'DM Sans', sans-serif"
            >
              {{ $t("bookingDuration.dinnerTime") }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getFirestore,
  collection,
  addDoc,
  serverTimestamp,
} from "firebase/firestore";
import { getAuth } from "firebase/auth";

export default {
  name: "BookingDuration",
  methods: {
    async handleClick(duration) {
      const auth = getAuth();
      const user = auth.currentUser;

      if (!user || !user.emailVerified) {
        this.$router.push("/login");
        return;
      }

      const db = getFirestore();
      try {
        // ✅ Save duration before creating reservation
        localStorage.setItem("duration", duration);

        // Create new reservation
        const docRef = await addDoc(collection(db, "reservations"), {
          userId: user.uid,
          duration: duration,
          status: "pending",
          preorder: false,
          createdAt: serverTimestamp(),
        });

        localStorage.setItem("reservationId", docRef.id);


        // Navigate to booking form
        this.$router.push("/booking");
        //localStorage.removeItem("duration");
      } catch (error) {
        console.error("Error saving reservation:", error);
      }
    },
  },
};
</script>
